import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { ITireModel, defaultValue } from 'app/shared/model/tire-model.model';
import { toast } from 'react-toastify';
import { translate } from 'react-jhipster';

const initialState: EntityState<ITireModel> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/tire-models';

interface IPagedTireModelQueryParams extends IQueryParams {
  nameSearch?: string;
}

// Actions

export const getEntities = createAsyncThunk('tireModel/fetch_entity_list', async ({ page, size, sort }: IQueryParams) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}&` : '?'}cacheBuster=${new Date().getTime()}`;
  return axios.get<ITireModel[]>(requestUrl);
});

export const getEntitiesByNameSearch = createAsyncThunk('tireModel/fetch_entity_list', async ({ page, size, sort, nameSearch }: IPagedTireModelQueryParams) => {
  const requestUrl = `${apiUrl}?${sort ? `page=${page}&size=${size}&sort=${sort}&nameSearch=${nameSearch}&` : ''}cacheBuster=${new Date().getTime()}`;
  return axios.get<ITireModel[]>(requestUrl);
});

export const getEntity = createAsyncThunk(
  'tireModel/fetch_entity',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get<ITireModel>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);

export const createEntity = createAsyncThunk(
  'tireModel/create_entity',
  async (entity: ITireModel) => {
    const result = await axios.post<ITireModel>(apiUrl, cleanEntity(entity));
    return result;
  },
  { serializeError: serializeAxiosError }
);

export const updateEntity = createAsyncThunk(
  'tireModel/update_entity',
  async (entity: ITireModel) => {
    const result = await axios.put<ITireModel>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    return result;
  },
  { serializeError: serializeAxiosError }
);

export const partialUpdateEntity = createAsyncThunk(
  'tireModel/partial_update_entity',
  async (entity: ITireModel) => {
    const result = await axios.patch<ITireModel>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    return result;
  },
  { serializeError: serializeAxiosError }
);

export const deleteEntity = createAsyncThunk(
  'tireModel/delete_entity',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}`;
    const result = await axios.delete<ITireModel>(requestUrl);
    return result;
  },
  { serializeError: serializeAxiosError }
);

// slice

export const TireModelSlice = createEntitySlice({
  name: 'tireModel',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getEntity.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addCase(deleteEntity.fulfilled, state => {
        state.updating = false;
        state.updateSuccess = true;
        state.entity = {};
      })
      .addMatcher(isFulfilled(getEntities, getEntitiesByNameSearch), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
          totalItems: parseInt(action.payload.headers['x-total-count'], 10),
        };
      })
      .addMatcher(isFulfilled(createEntity, updateEntity, partialUpdateEntity), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })
      .addMatcher(isPending(getEntities, getEntity, getEntitiesByNameSearch), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isPending(createEntity, updateEntity, partialUpdateEntity, deleteEntity), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = TireModelSlice.actions;

// Reducer
export default TireModelSlice.reducer;
